import React from 'react';
import styles from './Checkbox.module.scss';
import classNames from 'classnames';

export interface CheckboxProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  label: string;
  name: string;
  checked?: boolean;
  'data-testid'?: string;
  className?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ onChange, label, name, checked, 'data-testid': dataTestId, className }, ref) => {
    const id = `checkbox-${name}`;

    return (
      <label className={classNames(styles.label, className)} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className={styles.checkbox}
          onChange={onChange}
          data-testid={dataTestId}
          name={name}
          ref={ref as React.LegacyRef<HTMLInputElement>}
          {...(checked !== undefined ? { checked } : {})}
        />
        <span className={styles.customCheckbox}></span>
        {label}
      </label>
    );
  },
);

export default Checkbox;
